
import BaseModel from "./BaseModel";
import RelationOneToOne from "./RelationOneToOne";

export default class RelationOneToMany<ToClass extends BaseModel> extends RelationOneToOne<ToClass> {

  protected set_backreference() {
    if (this.from.className != this.fromClassName) {
      console.error(
        `RelationOneToOne: Object with id '${this.from.id}' is not a valid source. Expected ${this.fromClassName}, got '${this.from.className}'`,
      );
    } else {
      if (this._to) {
        (this._to as any)[this.backReferencePropertyName].push(this.from);
        this._to.raiseOnChangeUI(this.backReferencePropertyName);
        this._to.raiseOnChangeUI("childCollection");

      }
    }
  }


  protected remove_backreference() {
    if (this._to) {
      const index = (this._to as any)[this.backReferencePropertyName]?.indexOf(this.from);
      if (index >= 0) {
        //
        // Remove this.from from backpointer array
        //
        (this._to as any)[this.backReferencePropertyName].splice(index, 1);

        this._to.raiseOnChangeUI(this.backReferencePropertyName);
        this._to.raiseOnChangeUI("childCollection");
      }
    }
  }

}
